/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/extensions */
/* eslint-disable max-len */

import React from "react";
import { Fade } from "react-awesome-reveal";
import Button from "../elements/Button";
import BuildWebsite from "../assets/images/hero/BuildWebsite.png";
import TypingWords from "../components/TypingWords";

export default function Hero() {
  return (
    <header className="relative overflow-hidden bg-premium-light">
      <div className="container mx-auto px-6 py-16 lg:py-24">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-12">

          {/* TEXT */}
          <div className="flex-1 min-w-0 text-center lg:text-left max-w-2xl">
            <Fade direction="up" triggerOnce>
              <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-5-5xl font-extrabold text-surface-900 leading-tight tracking-tight">
                Have our <TypingWords />
                <br />
                <span className="block mt-2">Experience and save your money</span>
                <span className="block">with <span className="gradient-text">DNS Computer.</span></span>
              </h1>

              <p className="mt-6 text-base sm:text-lg text-surface-300 leading-relaxed max-w-xl mx-auto lg:mx-0">
                The most reliable IT solutions for small businesses. With DNS Computer,
                you&apos;ll spend less time figuring out technology and more time growing your business.
                Leave the IT to us.
              </p>

              <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
                <Fade direction="up" delay={200} triggerOnce>
                  <Button
                    href="/book-consultation"
                    type="link"
                    className="btn-premium text-base px-8 py-4"
                    aria-label="Book a Consultation"
                  >
                    Book a Consultation
                    <svg className="w-4 h-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                    </svg>
                  </Button>
                </Fade>

                <Fade direction="up" delay={350} triggerOnce>
                  <Button
                    href="/services"
                    type="link"
                    className="btn-outline-premium text-base px-8 py-4"
                  >
                    Explore Services
                  </Button>
                </Fade>
              </div>
            </Fade>
          </div>

          {/* IMAGE */}
          <div className="flex-shrink-0 flex items-center justify-center lg:justify-end">
            <Fade direction="up" delay={350} triggerOnce>
              <img
                src={BuildWebsite}
                alt="DNS Computer mascot"
                loading="lazy"
                className="h-48 sm:h-56 md:h-72 lg:h-[400px] xl:h-[480px] w-auto object-contain animate-float"
                style={{
                  filter: "drop-shadow(0 20px 40px rgba(16,185,129,0.12))",
                }}
              />
            </Fade>
          </div>

        </div>
      </div>
    </header>
  );
}
